import { useSelector } from 'react-redux';

import { offerSelector } from '../../../../../selectors';
import { IFeatureItem } from '../../../../../types/offerData';
import { getDealType, isRent } from '../../../../../utils/deal_type';
import { getOfferType, isSuburban } from '../../../../../utils/offer_type';

export const useFeaturesAdditionallyProps = () => {
  const offer = useSelector(offerSelector);

  const dealType = getDealType(offer);
  const isRentOffer = isRent(dealType);

  const offerType = getOfferType(offer);
  const isSuburbanOffer = isSuburban(offerType);

  if (!isSuburbanOffer || !isRentOffer) {
    return null;
  }

  const featuresList: IFeatureItem[] = [];

  if (offer.hasBathhouse) {
    featuresList.push({
      theme: 'banya',
      name: 'Баня',
    });
  }
  if (offer.hasGarage) {
    featuresList.push({
      theme: 'garage',
      name: 'Гараж',
    });
  }

  if (offer.hasPool) {
    featuresList.push({
      theme: 'pool',
      name: 'Бассейн',
    });
  }

  if (!featuresList.length) {
    return null;
  }

  return {
    title: 'Дополнительно',
    featuresList,
  };
};
